import { render, staticRenderFns } from "./CLabelText.vue?vue&type=template&id=7c92d84e"
import script from "./CLabelText.vue?vue&type=script&lang=js"
export * from "./CLabelText.vue?vue&type=script&lang=js"
import style0 from "./CLabelText.vue?vue&type=style&index=0&id=7c92d84e&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c92d84e')) {
      api.createRecord('7c92d84e', component.options)
    } else {
      api.reload('7c92d84e', component.options)
    }
    module.hot.accept("./CLabelText.vue?vue&type=template&id=7c92d84e", function () {
      api.rerender('7c92d84e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CLabelText.vue"
export default component.exports